import { createSlice } from "@reduxjs/toolkit";
import { getDepartmentDoctor, getDoctorTimeslots, updateAppointment } from "./RescheduleAppointmentThunk";

const initialState = {
  getDoctorListSuccess: null,
  getDoctorListError: null,
  doctorTimeslotsSuccess: null,
  doctorTimeslotsError: null,
  updatedAppointmentSuccess: null,
  updateAppointmentError: null,
};

const rescheduleAppointmentSlice = createSlice({
  name: "rescheduleAppointmentSlice",
  initialState,
  reducers: {
    resetGetDoctorList(state) {
      state.getDoctorListSuccess = null;
      state.getDoctorListError = null;
    },
    resetDoctorTimeslots(state) {
      state.doctorTimeslotsSuccess = null;
      state.doctorTimeslotsError = null;
    },
    resetUpdatedAppointment(state) {
      state.updatedAppointmentSuccess = null;
      state.updateAppointmentError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // --- Get Doctors ---
      .addCase(getDepartmentDoctor.fulfilled, (state, action) => {
        state.getDoctorListSuccess = action.payload;
        state.getDoctorListError = null;
      })
      .addCase(getDepartmentDoctor.rejected, (state, action) => {
        state.getDoctorListError = action.error.message;
      })

      // --- Get Doctor Timeslots ---
      .addCase(getDoctorTimeslots.fulfilled, (state, action) => {
        state.doctorTimeslotsSuccess = action.payload;
        state.doctorTimeslotsError = null;
      })
      .addCase(getDoctorTimeslots.rejected, (state, action) => {
        state.doctorTimeslotsError = action.error.message;
      })

      // --- Update Appointment ---
      .addCase(updateAppointment.fulfilled, (state, action) => {
        state.updatedAppointmentSuccess = action.payload;
        state.updateAppointmentError = null;
      })
      .addCase(updateAppointment.rejected, (state, action) => {
        state.updateAppointmentError = action.error.message;
      });
  },
});

export const {
  resetGetDoctorList,
  resetDoctorTimeslots,
  resetUpdatedAppointment,
} = rescheduleAppointmentSlice.actions;

export default rescheduleAppointmentSlice.reducer;
